/**
 * The Fabrica admin portal, DebtCollectify's way: any address with `?admin=true` (for
 * example `/signin?admin=true`) puts this browser tab in admin mode, so signing in opens the
 * Fabrica platform's workspaces (`/WorkSpace/0`) instead of the school portal. `?admin=false` leaves it.
 * Kept in sessionStorage because the query string is lost on the B2C sign-in round trip.
 * Only a role granted Fabrica's Fabrica.Admin operation may use the portal (the API checks every
 * call); everyone else gets the normal flow.
 */

const KEY = 'camptain.landingMode';

/** Reads `?admin=` from the address, once at start. */
export function readAdminModeFromUrl(search: string = typeof window === 'undefined' ? '' : window.location.search): void {
  const admin = new URLSearchParams(search).get('admin');
  if (admin === null) return;
  try {
    sessionStorage.setItem(KEY, admin === 'true' ? 'admin' : 'default');
  } catch {
    // Storage blocked: admin mode simply does not stick.
  }
}

export function isAdminMode(): boolean {
  try {
    return sessionStorage.getItem(KEY) === 'admin';
  } catch {
    return false;
  }
}

export function leaveAdminMode(): void {
  try {
    sessionStorage.setItem(KEY, 'default');
  } catch {
    // nothing to undo
  }
}

export const FABRICA_HOME = '/fabrica';
/** Where an admin-mode sign-in lands: the ported Fabrica platform's workspaces, as in DebtCollectify. */
export const FABRICA_PLATFORM_HOME = '/WorkSpace/0';
